module.exports = __webpack_public_path__ + "img/COM-i-1-I.d66f6a65.png";